import { ISpecieItemResponse, ISpecieResponse } from "./specie.interface";
import { useEffect, useState } from "react";

import { GET_ALL_SPECIES } from "./specie.query";
import { IOptionGeneric } from "../../shared/interface";
import { useQuery } from "@apollo/client";

export const useSpecies = () => {
  const [species, setSpecies] = useState<IOptionGeneric[]>([]);
  const { loading, error, data } = useQuery<{ species: ISpecieResponse }>(GET_ALL_SPECIES);

  useEffect(() => {
    if (data) {
      setSpecies(specieResponseMap(data.species));
    }
  }, [data]);

  return {
    species,
    loading,
    error,
  };
};

const specieResponseMap = ({ items }: ISpecieResponse): IOptionGeneric[] => {
  return items
    .map((item: any) => item.species)
    .map((specie: ISpecieItemResponse) => ({
      value: specie.id,
      label: specie.name,
    }));
};
